module.exports = __webpack_public_path__ + "static/media/AboutPage2Img4.ae2dde85.png";